export const HEADERS = {
    ewaybill_no : 'E-way Bill No',
    invoice_no:"Invoice No",
    lr_no :'LR No',
    ewaybill_expiry : 'E-way Bill Expiry Date',
    delivery_reference_no : 'Delivery Reference No',
    order_reference_no : 'Order Reference No',
    status : "Status",
    actions : "Extend"
}
export const TITLE = 'E-way Bill'

export const extend = {
    title : "Extend E-way Bill",
    ewaybill_no :{
        title :"E-way Bill No"
    } ,
    vehicle_no : {
        title :"Vehicle Number"
    },
    from_city:{
        title:"From City",
        placeholder : "Select City"
    },
    from_pincode : {
        title : "From City Pincode"
    },
    from_state : {
        title:"From State"
    },
    remaining_distance : {
        title:"Remaining Distance"
    },
    reason :{
        title:"Reason",
        placeholder:"Select Reason"
    },
    reason_remark:{
        title:"Reason Remark"
    },
    trans_doc_no : {
        title:"Transport Document Number"
    },
    trans_doc_date: {
        title: "Transport Document Date"
    },
    transit_type : {
        title : "Transit Type",
        placeholder : "Select Transit Type"
    },
    consignment_status : {
        title : "Consignment Status",
        placeholder : "Select Status"
    },
    address : {
        title:"Address"
    },
    Buttons : {
        cancel : "Cancel",
        submit : "Submit"
    }

}

export const ewaybill_title = {
    Buttons : {
        new : "New",
        export :"Export",
        filter : "Filter"
    }
}